import React from "react";

const AnnualGeneralMeeting = () => {
  return <div>AnnualGeneralMeeting</div>;
};

export default AnnualGeneralMeeting;
